import React from "react";

export const socialData = [
  {
    id:1,
    title: "LinkedIn",
    subtitle: "Join our Page",
   // icon: "https://media.omnibase.in/icons/socials/telegram.png",
    icon: "https://cdn.iconscout.com/icon/free/png-256/free-linkedin-logo-icon-svg-download-png-1581908.png?f=webp",
    buttonText : "Join Page",
    link:"https://github.com/Mamoon123d?tab=repositories&q=&type=&language=&sort=",
    dateTime:"30 October 2025, 01:56 PM"
  },
  {
    id:2,
    title: "YouTube",
    subtitle: "Join our Page",
    icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/960px-YouTube_full-color_icon_%282017%29.svg.png",
    buttonText : "Join Page",
    link:"google.com",
    dateTime:"30 October 2025, 01:56 PM"
  },
  {
    id:3,
    title: "Instagram",
    subtitle: "Join our Page",
    //icon: "https://media.omnibase.in/icons/socials/telegram.png",
    icon: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png",
    buttonText : "Join Page",
    link:"google.com",
    dateTime:"30 October 2025, 01:56 PM"
  },
  {
    id:4,
    title: "telegram",
    subtitle: "Join our Page",
    icon: "https://media.omnibase.in/icons/socials/telegram.png",
    buttonText : "Join Page",
    link:"google.com",
    dateTime:"30 October 2025, 01:56 PM"
  },
];
